import { Injectable } from '@angular/core';
import { FormCode } from '../enums/form-code.enum';
import { FormName } from '../enums/form-name.enum';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MontazaService {
  public montazaDataSubject: Subject<any> = new Subject();
  public montazaData$: Observable<any> = this.montazaDataSubject.asObservable();

  public emisijaDataSubject: Subject<any> = new Subject();
  public emisijaData$: Observable<any> = this.emisijaDataSubject.asObservable();

  public premestiEmisijuSubject: Subject<any> = new Subject();
  public premestiEmisiju$: Observable<
    any
  > = this.premestiEmisijuSubject.asObservable();

  public sacuvajMontazuSubject: Subject<any> = new Subject();
  public sacuvajMontazu$: Observable<
    any
  > = this.sacuvajMontazuSubject.asObservable();

  private _montaza: any;
  private _programId: string;
  private _datum: any;

  private _izvestajData: any;

  constructor() {}

  get programId(): string {
    return this._programId;
  }

  setProgramId(programId: string) {
    this._programId = programId;
  }

  setDatum(datum: any) {
    this._datum = datum;
  }

  get datum(): any {
    return this._datum;
  }

  setMontaza(montaza: any) {
    this._montaza = montaza;
  }

  get montaza(): any {
    return this._montaza;
  }

  setIzvestajData(data: any) {
    this._izvestajData = data;
  }

  get izvestajData(): any {
    return this._izvestajData;
  }

  updateBlokovi(blokovi: any[], emisijaRasporedId: any) {
    this._montaza.Blokovi = this._montaza.Blokovi.filter(
      b => b.EmisijaRasporedId !== emisijaRasporedId
    );

    const noviBlokovi = blokovi.filter(
      b => b.EmisijaRasporedId === emisijaRasporedId
    );

    this._montaza.Blokovi = [...this._montaza.Blokovi, ...noviBlokovi];
  }

  updateSviBlokovi(blokovi: any[]) {
    this._montaza.Blokovi = blokovi;
  }

  updateEmisija(emisija) {
    const index = this._montaza.EmisijaRasporedi.findIndex(
      b => b.Id === emisija.Id
    );

    if (index !== -1) {
      this._montaza.EmisijaRasporedi[index] = emisija;
    }
  }

  updateOpis(opis) {
    this._montaza.Opis = opis;
  }

  resetData() {
    this._montaza = null;
    this._programId = null;
    this._datum = null;
  }

  getMontazaSettings() {
    return {
      additable: true,
      allFields: [
        this.getProgramFieldSettings(),
        this.getBlokFieldSettings(),
        this.getVremeFieldSettings(),
        this.getDozvoljenoFieldSettings(),
        this.getCenaFieldSettings(),
        this.getNazivFieldSettings(),
        this.getEmisijaFieldSettings(),
        this.getDateSettings(),
        this.getTargetDateSettings(),
        this.getSpotFieldSettings(),
        this.getSpotLessFiltersFieldSettings(),
        this.getBilbordSettings(),
        this.getUgovorSettings(),
        this.getBrendSpicaFieldSettings(),
      ],
      completerMainAndSecond: false,
      completerMainField: null,
      completerSecondField: null,
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable: ['111-111-111'],
      },
      fromCode: '',
      group: 'Montaza',
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name: 'Montaza',
      relations: [
        this.getRelationSettings('Program', 'Sifra', 'Naziv', [
          this.getProgramFieldSettings().id,
        ]),
        this.getRelationSettings(
          'EmisijaRaspored',
          'EmisijaNaziv',
          'Trajanje',
          [this.getEmisijaFieldSettings().id]
        ),
        this.getRelationSettings('Spot', 'Sifra', 'Naziv', [
          this.getSpotFieldSettings().id,
        ]),
        this.getRelationSettings('SpotLessFilters', 'Sifra', 'Naziv', [
          this.getSpotLessFiltersFieldSettings().id,
        ]),
        this.getRelationSettings('Ugovor', 'BrojUgovora', 'BrojPodugovora', [
          this.getUgovorSettings().id,
        ]),
        this.getRelationSettings(
          'BrendiranaSpicaMontaza',
          'SpotNaziv',
          'SpotSifra',
          [this.getBrendSpicaFieldSettings().id]
        ),
      ],
      title: 'Montaza',
      type: 'montaza',
      path: '',
      _id: '51073157',
    };
  }

  getProgramFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Program',
      entityType: 'MontazaProgramEnum',
      id: '222-222-222',
      label: 'Program',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Program',
      path: null,
      type: 'comboFixed',
      width: 10,
    };
  }

  getBlokFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Blok',
      entityType: 'MontazaBlokEnum',
      id: '111-blok',
      label: 'Blok',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Blok',
      path: null,
      type: 'comboFixed',
      width: 10,
    };
  }

  getEmisijaFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'EmisijaRaspored',
      entityType: 'EmisijaRaspored',
      id: '777-777-777',
      label: 'Emisija raspored',
      lookupFormCode: FormCode.MSMON_EMI,
      lookupFormName: FormName.Montaza,
      mandatory: false,
      name: 'EmisijaRaspored',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getSpotFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Spot',
      entityType: 'Spot',
      id: '888-888-888',
      label: 'Spot',
      lookupFormCode: 'MSSPO_SPO',
      lookupFormName: 'Pregled spotova',
      mandatory: false,
      name: 'Spot',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getSpotLessFiltersFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'SpotLessFilters',
      entityType: 'Spot',
      id: '123-321-456',
      label: 'Spot',
      lookupFormCode: 'MSSPO_MSPO',
      lookupFormName: 'Pregled spotova za montazu',
      mandatory: false,
      name: 'SpotLessFilters',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getBilbordSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Spot',
      entityType: 'Spot',
      id: '9191919',
      label: 'Bilbord',
      lookupFormCode: 'MSSPO_SPO',
      lookupFormName: 'Pregled spotova',
      mandatory: false,
      name: 'Bilbord',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getUgovorSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'Ugovor',
      entityType: 'Ugovor',
      id: '9999999998',
      label: 'Ugovor',
      lookupFormCode: 'MSUGO_PZS',
      lookupFormName: 'Pregled ugovora',
      mandatory: false,
      name: 'Ugovor',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getVremeFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: true,
      fieldKey: 'Vreme',
      id: '444-444-444',
      label: 'Vreme',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Vreme',
      path: null,
      type: 'input',
      width: 10,
    };
  }

  getDozvoljenoFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: true,
      fieldKey: 'Dozvoljeno',
      id: '555-555-555',
      label: 'Dozvoljeno',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Dozvoljeno',
      path: null,
      type: 'input',
      width: 10,
    };
  }

  getCenaFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: true,
      fieldKey: 'Cena',
      id: '666-666-666',
      label: 'Cena',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Cena',
      path: null,
      type: 'input',
      width: 10,
    };
  }

  getNazivFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: true,
      fieldKey: 'Naziv',
      id: '666-666-666',
      label: 'Naziv',
      lookupFormCode: null,
      lookupFormName: null,
      mandatory: false,
      name: 'Naziv',
      path: null,
      type: 'input',
      width: 10,
    };
  }

  getDateSettings() {
    return {
      additable: true,
      dateRange: false,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'datum',
      id: '333-333-333',
      javaFieldType: 'java.util.Date',
      label: 'Period',
      mandatory: true,
      name: 'Datum',
      path: 'Montaza',
      type: 'date',
      width: 92,
    };
  }

  getTargetDateSettings() {
    return {
      additable: true,
      dateRange: false,
      dbType: 'BIGINT',
      default: true,
      editable: true,
      fieldKey: 'TargetDatum',
      id: '777-777-777',
      javaFieldType: 'java.util.Date',
      label: 'Period',
      mandatory: true,
      name: 'TargetDatum',
      path: 'Montaza',
      type: 'date',
      width: 92,
    };
  }

  getBrendSpicaFieldSettings() {
    return {
      additable: true,
      dbType: 'VARCHAR(25)',
      default: true,
      editable: false,
      fieldKey: 'BrendiranaSpicaMontaza',
      entityType: 'BrendiranaSpicaMontaza',
      id: '123-123-bs',
      label: 'Spot',
      lookupFormCode: 'MSUGOMON_BRESPIC',
      lookupFormName: 'Pregled spotova',
      mandatory: false,
      name: 'BrendSpica',
      path: null,
      type: 'completer',
      width: 10,
    };
  }

  getRelationSettings(
    name: string,
    completerMainField: string,
    completerSecondField: string,
    lookupTable: Array<any>
  ) {
    return {
      additable: true,
      allFields: [],
      completerMainAndSecond: true,
      completerMainField,
      completerSecondField,
      deletable: true,
      details: [],
      documentType: 'Sifarnik',
      editable: true,
      fetchObject: 'basic',
      filterFields: [],
      formSettings: {
        header: [
          {
            title: 'Podaci',
            panels: [
              {
                title: 'Panel 1',
                panelVisible: false,
                expanded: true,
                controls: [[], []],
              },
            ],
          },
        ],
        table: [],
        lookupTable,
      },
      fromCode: '',
      group: name,
      idProperty: 'Id',
      inlineAdding: true,
      inlineEditing: true,
      lazyListSource: 'mainAndSecond',
      name,
      relations: [],
      title: name,
      type: name,
      _id: '51073157',
    };
  }

  hasError(response: any) {
    return (
      response['Errors'] &&
      response['Errors'].length &&
      response['Errors'][0]['ErrorMessage']
    );
  }

  mapBrendiraneSpiceToSadrzaj(brendiraneSpice: any[], jeSpica: boolean) {
    return brendiraneSpice.map(brendiranaSpica => {
      return {
        BrendiranaSpicaId: brendiranaSpica.BrendiranaSpicaId,
        VrstaSpotaId: brendiranaSpica.VrstaSpotaId,
        VremeOd: brendiranaSpica.VremeOd,
        VremeDo: brendiranaSpica.VremeDo,
        SpotId: brendiranaSpica.SpotId,
        Sifra: brendiranaSpica.SpotSifra,
        Naziv: brendiranaSpica.SpotNaziv,
        TrajanjeSekunde: brendiranaSpica.SpotTrajanje,
        SpotTrajanjeEstimacija: brendiranaSpica.SpotTrajanjeEstimacija,
        VremeTrajanjaServer: brendiranaSpica.VremeTrajanjaServer,
        Spica: brendiranaSpica.Spica,
        JeSpica: jeSpica,
        UgovorId: brendiranaSpica.Podugovor.UgovorId,
        BrojUgovora: brendiranaSpica.Podugovor.BrojUgovora,
        PodugovorId: brendiranaSpica.Podugovor.Id,
        BrojPodugovora: brendiranaSpica.Podugovor.BrojPodugovora,
        KlijentId: brendiranaSpica.Podugovor.KlijentId,
        KlijentNaziv: brendiranaSpica.Podugovor.KlijentNaziv,
      };
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/montaza.service.ts